import { svg } from "lit";
const icon = svg `<path d="M7 42.9999V16.6538H5V5H42.9999V16.6538H40.9999V42.9999H7ZM9.2692 40.7307H38.7307V16.6538H9.2692V40.7307ZM7.2692 14.3846H40.7307V7.2692H7.2692V14.3846ZM18.3846 26.1345H29.6153V24H18.3846V26.1345Z" fill="currentColor"/>`;
export default icon;
